import { render, staticRenderFns } from "./SourceDomain.vue?vue&type=template&id=b1dcfcf4&scoped=true&"
import script from "./SourceDomain.vue?vue&type=script&lang=js&"
export * from "./SourceDomain.vue?vue&type=script&lang=js&"
import style0 from "./SourceDomain.vue?vue&type=style&index=0&id=b1dcfcf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dcfcf4",
  null
  
)

/* custom blocks */
import block0 from "./SourceDomain.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports